import { MinusOutlineIcon } from "../icon/MinusOutlineIcon";

interface Props {
  handleClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

export const GrayMinusButton: React.FC<Props> = ({ handleClick, disabled }) => {
  return (
    <button
      className="flex justify-center items-center h-[20px] w-[20px] rounded-[4px] border border-semantic-divider bg-grayscale-contrast-2 text-grayscale-contrast-70"
      onClick={disabled ? () => {} : handleClick}
      disabled={disabled}
    >
      <MinusOutlineIcon size={10} color="text-grayscale-contrast-70" />
    </button>
  );
};
